import React from "react";
import { Link, useHistory } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { AuthInput, AuthButton, Timer } from "../../components/index";

const ForgetVerification = () => {
  const router = useHistory();
  const handleVerify = async (code) => {
    localStorage.setItem("userCode", code);
    router.push("/reset");
  };
  return (
    <div className='container'>
      <div className='auth'>
        <div className='logo'>
          <Link to='/'>
            <img src='/images/logo.png' alt='logo' />
          </Link>
        </div>
        <div className='form-list'>
          <Formik
            initialValues={{
              code: "",
            }}
            validationSchema={Yup.object({
              code: Yup.string().required("کد ارسالی را وارد کنید"),
            })}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              setTimeout(() => {
                handleVerify(values.code);
                setSubmitting(false);
              }, 300);
            }}
          >
            {(props) => (
              <Form>
                <AuthInput
                  placeholder={"کد تایید"}
                  name='code'
                  type='text'
                  icon={<Timer start={2} />}
                />
                <AuthButton title={"تایید کد ارسال"} />
              </Form>
            )}
          </Formik>
        </div>
        <div className='auth-link'>
          <div>
            <span>برای برگشت به مرحله قبل</span>
            <Link to='/forget'>کلیک کنید </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ForgetVerification;
